import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Button } from 'reactstrap';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMapPin } from '@fortawesome/free-solid-svg-icons';
import { loadCampaignMap } from '../../actions/filterActions';
import { fetchPlanoCampaigns, setViewCampaignPane, exportExcel, deletePlanoCampaign } from '../../actions/planoCampaignActions';
// import SharePlanoCampaign from './sharePlanoCampaign';
import DownloadPPTComponent from "./downloadPPT";
import Map from './maps';
const Link = require("react-router-dom").Link;

library.add(faMapPin);

class Campaigns extends Component {

    state = {

    }

    componentWillMount() {
        this.props.fetchPlanoCampaigns();
    }

    componentDidMount(){

    }


    handleViewCampaign = (item)=>{
        this.props.setViewCampaignPane(item);
    }

    handleCloseViewCampaign = ()=>{
        this.props.setViewCampaignPane({});
    }

    handleExportButton = (item)=>{
        const { exportExcel } = this.props;
        exportExcel(item);
    }

    handleDeleteButton = (item)=>{
        this.props.deletePlanoCampaign(item);
    }



    render() {


        let showCampaignDetails = false;
        let title = "";
        let subtitle = "";

        const { campaignName, startDate, endDate } = this.props.viewCampaignItem;

        if(campaignName){
            showCampaignDetails = true;
            title = campaignName;
            subtitle = "Start Date : "+startDate+", End Date : "+endDate
        }

        return (
            <div style={{ width: "100%", margin: "5px" }}>
                <Table responsive hover bordered striped>
                    <thead>
                        <tr>
                            <th>Campaign Name</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Delete</th>
                            <th>Download Excel</th>
                            <th>Download PPT</th>
                            <th>Show On Map</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.props.planoCampaigns.map((item, index) => {
                                const { campaignName, startDate, endDate, _id} = item;
                                return (
                                    <tr key={index}>
                                        <td>{campaignName}</td>
                                        <td>{startDate}</td>
                                        <td>{endDate}</td>
                                        <td><Button color="danger" onClick={this.handleDeleteButton.bind(this, item)}>Delete</Button></td>
                                        <td><Button color="info" onClick={this.handleExportButton.bind(this, item)}>Download Excel</Button></td>
                                        <td><DownloadPPTComponent campaign_id={_id}/></td>
                                        <td><Button color="info" onClick={this.props.loadCampaignMap.bind(this, "create_plano_campaign",campaignName)}>Show On Map</Button></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table> 
                {
                    showCampaignDetails && 
                    <SlidingPane isOpen={showCampaignDetails} onRequestClose={ this.handleCloseViewCampaign } title={title} subtitle={subtitle}>
                        <Map
                            loadingElement={<div style={{ height: `100%` }} />}
                            containerElement={<div style={{ height: '90vh', width: '75vw' }} />}
                            mapElement={<div style={{ height: `100%` }} />}
                            center={this.props.center}
                            viewCampaignItem={this.props.viewCampaignItem}/>
                    </SlidingPane>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        planoCampaigns: state.planoCampaigns.planoCampaigns,
        viewCampaignItem : state.planoCampaigns.viewCampaignItem
    }
}

export default connect(mapStateToProps, { fetchPlanoCampaigns, setViewCampaignPane,
                        exportExcel, deletePlanoCampaign,loadCampaignMap })(Campaigns);


// WEBPACK FOOTER //
// ./src/v3/components/campaign/campaigns.js